/*!

=========================================================
* Argon Dashboard React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import PropTypes from "prop-types";
import { 
  Button, 
  Container, 
  Row, 
  Col,
  Card,
  CardBody,
  CardTitle, 
} from "reactstrap";
import { connect } from "react-redux";
import compose from "recompose/compose";

import Dropzone from "custom-components/Dropzone.jsx";
import { 
  crudGetOneById as crudGetOneByIdAction,
} from 'store/actions/dataActions';
import { 
  showNotification as showNotificationAction
} from 'store/actions/notificationActions';
import { FETCH_API } from 'store/sagas/fetch';
import { 
  DOCUMENT_ANALYSIS_MAX_FILE_SIZE,
} from 'util/constants';


class DocumentAnalysisHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    // refresh / 분석이 성공했을 때
    if( nextProps.refreshVersion !== this.props.refreshVersion || 
        ( nextProps.item !== this.props.item )
    ) {
      this.setState({files: []})
      this.dropzone.removeAllFiles();
    }
  }

  // dropzone 
  initDropzone = (dz) => {
    //console.log("DocumentAnalysisHeader - initDropzone");
    this.dropzone = dz;
  }

  addFileAtState = (file, response) => {
    file.uuid = response.id;
    this.setState(prevState => ({
      files: prevState.files.concat([file])
    }));
  }

  removeFileAtState = (file) => {
    //console.log("remove file:",file)
    this.setState(prevState => ({
      files: prevState.files.filter( stateFile  => stateFile.upload.uuid !== file.upload.uuid )
    }));
  }

  // 업로드된 파일 체크
  checkUploadedFile = () => {
    // 아직 완료되지 않은 파일이 있는지 확인 
    const uncompletedFiles = this.dropzone.getUploadingFiles();
    if( uncompletedFiles && uncompletedFiles.length > 0 ) {
      this.props.dispatchShowNotification(
        `아직 업로드 중인 파일이 있습니다.(${uncompletedFiles.join(", ")}) 업로드가 완료된 뒤에 진행해주세요.`,
        'warning'
      );
      return false;
    }
    
    // 업로드 완료된 파일이 1개인지 확인
    const uploadedFiles = this.dropzone.getAcceptedFiles().filter(function(file) {
      return file.status === "success";
    });
    if( !uploadedFiles || uploadedFiles.length === 0 ) {
      this.props.dispatchShowNotification(
        '파일을 업로드해주세요.',
        'warning'
      );
      return false;
    }

    return uploadedFiles;
  }

  // 분석버튼 클릭
  onSubmit = () => {
    //console.log("onSubmit");

    // 파일 체크 후 요청
    const uploadedFiles = this.checkUploadedFile();
    if( uploadedFiles && uploadedFiles.length === 1 ) {
      this.props.dispatchCrudGetOneById(this.props.menu, uploadedFiles[0].uuid);
    }
  };


  render() {
    const { menu } = this.props;
    const { files } = this.state;
    const filename = files && files.length > 0 ? files[0].name : "";

    return (
      <form autoComplete="off" noValidate>
        <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
          <Container fluid>
            <Row>
              <Col>
                <h1 className="display-2 text-white text-center">SPIKE PDF-ion</h1>
                <p className="text-white mt-0 mb-0 text-center">
                  AI 분석을 위해 최적화된 형태로 문서를 추출해줍니다.<br/>
                  파일을 업로드해서 추출된 문서 내용을 확인해보세요.
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card className="card-stats mt-4 mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-muted mb-0"
                        >
                          PDF 파일 업로드
                        </CardTitle>
                        <Dropzone
                          uploadUrl={FETCH_API[`${menu}_UPLOAD`]}
                          autoProcessQueue={true}
                          maxFiles={1}
                          maxFilesize={DOCUMENT_ANALYSIS_MAX_FILE_SIZE}
                          acceptedFiles="application/pdf"
                          initDropzone={this.initDropzone}
                          addFileAtState={this.addFileAtState}
                          removeFileAtState={this.removeFileAtState}
                        />
                      </div>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-success">
                        하나의 PDF 파일
                      </span>{""}
                      <span className="text-nowrap">을 업로드해보세요.</span>
                    </p>
                    <div className="col text-right pr-0">
                      { filename && (
                        <Button
                          color="primary"
                          onClick={this.onSubmit}
                        >
                          {filename} 파일의 분석을 시작해볼까요?
                        </Button>
                      )}
                    </div>
                  </CardBody>
                </Card>
                </Col>
            </Row>
          </Container>
        </div>
      </form>
    );
  }
}


export default compose(
  connect(
    ( state, props ) => ({
      refreshVersion: state.main.refreshVersion,
      item: state.main.item,
    }), {
      dispatchCrudGetOneById: crudGetOneByIdAction,
      dispatchShowNotification: showNotificationAction,
    }
  ),
)(DocumentAnalysisHeader);

DocumentAnalysisHeader.propTypes = {
  menu: PropTypes.string.isRequired,
};